import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Heading,
  Text,
  Card,
  CardBody,
  CardHeader,
} from "@chakra-ui/react";
import WidgetForm from "./WidgetForm";
import axios from "../../axiosConfig";

const WidgetNew = () => {
  const navigate = useNavigate();

  const handleCreateWidget = async (widgetData) => {
    try {
      await axios.post("/widgets", { widget: widgetData });
      navigate("/app/widget"); // go back to list after success
    } catch (error) {
      console.error("Error creating widget:", error);
    }
  };

  return (
    <Box mx="auto" p={6} maxW="container.2xl">
      <Card>
        <CardHeader>
          <Heading as="h2" size="lg">
            Create New Widget
          </Heading>
          <Text fontSize="lg" color="gray.500">
            Add a new widget with details, overview, and reflection
          </Text>
        </CardHeader>
        <CardBody>
          <WidgetForm
            onSubmit={handleCreateWidget}
            onCancel={() => navigate("/app/widget")}
          />
        </CardBody>
      </Card>
    </Box>
  );
};

export default WidgetNew;